var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { cols: "12", id: "main_content_maxwidthset" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0",
              attrs: {
                align: "center",
                id: "header_height",
                justify: "space-between",
              },
            },
            [
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    [
                      _vm.tokenExisted && _vm.isMainRole
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-0",
                              class: {
                                current_btn: _vm.currentRoute == "adminPage",
                              },
                              attrs: {
                                width: "12rem",
                                height: "50px",
                                id: "header_btn",
                                elevation: "0",
                              },
                              on: { click: _vm.goAdminPage },
                            },
                            [_vm._v(" " + _vm._s("X-API-KEY / Role") + " ")]
                          )
                        : _vm._e(),
                      _vm.isMainRole
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-0",
                              class: {
                                current_btn:
                                  _vm.currentRoute == "testDeviceData",
                              },
                              attrs: {
                                width: "13rem",
                                height: "50px",
                                id: "header_btn",
                                elevation: "0",
                              },
                              on: { click: _vm.goTestDevicePage },
                            },
                            [
                              _vm._v(
                                " " + _vm._s("테스트 디바이스 데이터관리") + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          class: {
                            current_btn: _vm.currentRoute == "testDeviceChange",
                          },
                          attrs: {
                            width: "13rem",
                            height: "50px",
                            id: "header_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.goDeviceChangePage },
                        },
                        [_vm._v(" " + _vm._s("장비교체 테스트") + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          class: {
                            current_btn: _vm.currentRoute == "testPage",
                          },
                          attrs: {
                            width: "13rem",
                            height: "50px",
                            id: "header_btn",
                            elevation: "0",
                          },
                          on: { click: _vm.goUITestPage },
                        },
                        [_vm._v(" " + _vm._s("UI 테스트") + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { cols: "auto", align: "right" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0 pr-3",
                      attrs: { align: "center", justify: "end" },
                    },
                    [
                      _vm._v(" " + _vm._s("UMembers 로그인 : ") + " "),
                      _vm.tokenExisted
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 ml-3",
                              staticStyle: {
                                color: "green",
                                "font-weight": "bold",
                              },
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.tokenExisted))]
                          )
                        : _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 ml-3",
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold",
                              },
                              attrs: { cols: "auto" },
                            },
                            [_vm._v(_vm._s(_vm.tokenExisted))]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }